/*!
 * @Author: leo
 * @Date: 2019-12-27 18:12:00
 * @Last Modified by: leo
 * @Last Modified time: 2019-12-27 18:12:00
 * @Introduction: 城市地址
 */

import cloneDeep from 'lodash/cloneDeep'

const CodeToText: any = {}   // code转汉字，支持省市区
const TextToCode: any = {}   // 汉字转code大对象，只支持省
const regionData: any = []   
let provinceAndCityData: any = []

const initRegion = (data: any) => {
    // 计算省/市
    for (let i = 0, len = data.length; i < len; i++) {
        const provinceChildren = []
        regionData.push({
            value: data[i].code,   // 省份code值
            label: data[i].name    // 省份汉字
        })
        CodeToText[data[i].code] = data[i].name
        TextToCode[data[i].name] = data[i]
        if (data[i].son_regions.length > 0) {
            for (let j = 0, len = data[i].son_regions.length; j < len; j++) {
                provinceChildren.push({
                    value: data[i].son_regions[j].code,
                    label: data[i].son_regions[j].name
                })
                CodeToText[data[i].son_regions[j].code] = data[i].son_regions[j].name
            }
        }
        if (provinceChildren.length) {
            regionData[i].children = provinceChildren
        }
    }

    provinceAndCityData = cloneDeep(regionData)

    // 计算区
    for (let i = 0, len = data.length; i < len; i++) {
        const cities = data[i].son_regions
        if (cities.length > 0) {
            for (let j = 0, len = cities.length; j < len; j++) {
                if (cities[j].son_regions.length > 0) {
                    const cityChildren = []
                    for (let k = 0, len = cities[j].son_regions.length; k < len; k++) {
                        cityChildren.push({
                            value: cities[j].son_regions[k].code,
                            label: cities[j].son_regions[k].name
                        })
                        CodeToText[cities[j].son_regions[k].code] = cities[j].son_regions[k].name
                    }
                    if (cityChildren.length) {
                        regionData[i].children[j].children = cityChildren
                    }
                }
            }
        }
    }
    
    return {
        provinceAndCityData, 
        regionData
    }
}

// 代码转文字 省，市，区
const convertCodeToText = (code: any) => {
    if (!code) return ''
    let [provinceCode, cityCode, districtCode] = code
    let text = ''
    let province = CodeToText[provinceCode]
    let city = CodeToText[cityCode]
    let district = CodeToText[districtCode]
    if (provinceCode && province) {
        text += province
        if (cityCode && CodeToText[cityCode]) {
            text += ',' + city
            if (districtCode && district) {
                text += ',' + district
            }
        }
    }
    return text
}

// 地域名称转code: 支持省市区
const convertTextToCode = (text: string[]) => {
    let [provinceText, cityText, districtText] = text 
    let code = []
    if (provinceText && TextToCode[provinceText]) {
        const province = TextToCode[provinceText]
        code.push(province.code)
        if (cityText) {
            const cities = province.son_regions
            let city: any
            for (let i = 0, len = cities.length; i < len; i++) {
                if (cityText === cities[i].name) {
                    city = cities[i]
                    code.push(city.code)
                }
            }
            if (districtText) {
                const districtes = city.son_regions
                const fn = (d: any) => d.name === districtText
                const district = districtes.filter(fn)[0]
                code.push(district.code)
            }
        }
    } else {
        code.push('')
    }
    return code
}

export {
    initRegion,
    CodeToText, 
    TextToCode,
    convertCodeToText,
    convertTextToCode
}
